<template>
  <div class="mt-4">
    <p class="subtitle-2 mb-2">Comprovante de endereço <small class="grey--text">(opcional)</small></p>

    <div v-if="existing_files.length" class="mb-3">
      <v-chip
        v-for="file in existing_files"
        :key="file.id"
        class="ma-1"
        color="blue-grey lighten-4"
        @click="openFile(file.url)"
      >
        <v-icon left small>mdi-file-document-outline</v-icon>
        {{ file.filename || 'Anexo' }}
      </v-chip>
    </div>

    <template v-if="!readonly">
      <v-file-input
        v-for="index in file_slots"
        :key="index"
        v-model="files[index - 1]"
        :label="`Comprovante ${index}`"
        accept="image/jpg, image/png, image/jpeg, application/pdf"
        prepend-icon="mdi-paperclip"
        show-size
        clearable
        class="mb-2"
        :rules="[validateFormat]"
        @change="handleFileChange"
      ></v-file-input>

      <div class="d-flex justify-end" v-if="!is_creating && has_new_files">
        <v-btn small color="success" :loading="saving" @click="uploadFiles">
          <v-icon left small>mdi-content-save</v-icon>
          Salvar anexos
        </v-btn>
      </div>
    </template>

    <dialog-loading loadingText="Salvando anexos" v-if="saving"></dialog-loading>
  </div>
</template>

<script>
import Api from '@/api/index'
import { mapActions } from 'vuex'

export default {
  name: 'AddressProofFiles',
  props: {
    driver_id: {
      type: [String, Number],
      default: null
    },
    address_proof_files_urls: {
      type: Array,
      default: () => []
    },
    is_creating: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    file_slots: {
      type: Number,
      default: 2
    }
  },
  data() {
    return {
      files: [null, null],
      saving: false,
      existing_files: [],
      validateFormat: v => !v || ["image/png", "application/pdf", "image/jpeg", "image/jpg"].includes(v?.type) || "Formato inválido. Permitidos: JPG, JPEG, PNG, PDF"
    }
  },
  computed: {
    has_new_files() {
      return this.files.some(file => file)
    }
  },
  methods: {
    ...mapActions({
      addNotification: 'Notification/add'
    }),
    handleFileChange() {
      this.$emit('filesChanged', this.files.filter(Boolean))
    },
    openFile(url) {
      window.open(url, '_blank')
    },
    prepareFormData(id) {
      const formData = new FormData()
      formData.append('driver[id]', parseInt(id))

      this.files.filter(Boolean).forEach(file => {
        formData.append('driver[address_proof_files][]', file)
      })

      return formData
    },
    uploadFiles(id) {
      const driverId = id || this.driver_id
      const selectedFiles = this.files.filter(Boolean)

      if (!driverId || !selectedFiles.length) return Promise.resolve()

      this.saving = true
      const formData = this.prepareFormData(driverId)

      return Api.Driver.updateWithFormData(formData).then(response => {
        const uploaded = response.data?.data?.attributes?.address_proof_files_urls || []
        this.existing_files = uploaded
        this.files = Array(this.file_slots).fill(null)
        this.addNotification({ type: 'success', msg: 'Comprovantes de endereço salvos com sucesso.' })
        this.$emit('uploaded', uploaded)
      }).catch(err => {
        console.log(err)
        this.addNotification({ type: 'error', msg: 'Não foi possível salvar os comprovantes de endereço.' })
      }).finally(() => {
        this.saving = false
      })
    },
    setExistingFiles(files) {
      this.existing_files = files || []
    }
  },
  watch: {
    address_proof_files_urls: {
      immediate: true,
      handler(files) {
        this.setExistingFiles(files)
      }
    }
  }
}
</script>
